// /my/blogs - Malaysia blog home (components/market/MarketBlogsPage). The
// cards come from lib/market-blogs.js; this is the page's own copy. "Aircond"
// first; nothing lifted from /sg/blogs.
const content = {
    title: 'Aircond & Fitness Guides for Kuala Lumpur | StringsSG Malaysia',
    description:
        'Guides for KL homes: aircond HP sizing, inverter vs non-inverter, condo aircond servicing, aircond tak sejuk, harga servis aircond, puasa workouts, pantang exercise and gym prices in KL.',
    about:
        'Welcome to the StringsSG Malaysia blog. Our guides are written for condos and landed homes in Kuala Lumpur and the Klang Valley: choosing and servicing your aircond, what servicing costs, and staying fit through puasa, pantang and a busy KL week. Some guides are in Bahasa Melayu.',
    h1: 'Latest Guides for Malaysian Homes and Fitness',
    // Category pages, by vertical: /my/blogs/aircond-guides, /my/blogs/fitness-guides.
    categories: {
        aircon: {
            title: 'Aircond Guides for KL Homes | StringsSG Malaysia',
            description: 'Aircond guides for Malaysian homes: aircond tak sejuk, harga servis aircond, HP room sizing, inverter vs non-inverter and condo servicing.',
            h1: 'Aircond Guides & Tips for Malaysian Homes',
        },
        pt: {
            title: 'Fitness Guides for Kuala Lumpur | StringsSG Malaysia',
            description: 'Fitness guides for KL: exercise after pantang, working out during puasa, gym membership prices, jurulatih peribadi and becoming a personal trainer in Malaysia.',
            h1: 'Fitness Guides & Training Tips for Malaysia',
        },
    },
}

export default content
